import React from 'react';

const Palette = () => {
  return (
    <svg
      width="39"
      height="34"
      viewBox="0 0 39 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3334 0C8.65598 0 0 7.41971 0 16.5708C0 17.7158 0.135334 18.8339 0.394186 19.9134C2.30497 23.2011 3.62715 21.126 9.66668 18.1057C15.8179 15.0295 9.66668 22.402 7.51853 26.6983C6.85797 28.0194 7.21564 29.1375 8.12001 30.0537C11.2842 31.9913 15.1488 33.1427 19.3334 33.1427C30.0107 33.1427 38.6667 25.7241 38.6667 16.5708C38.6667 7.41971 30.0107 0 19.3334 0ZM22.3934 26.2579C21.9691 27.7036 19.7512 28.3244 17.4387 27.6446C15.1262 26.9657 13.5956 25.2451 14.0199 23.7983C14.4442 22.3526 16.6621 21.7318 18.9746 22.4127C21.2871 23.0905 22.8177 24.8111 22.3934 26.2579Z"
        fill="#D99E82"
      />
      <path
        d="M10.7408 11.6613C12.5204 11.6613 13.963 10.2186 13.963 8.43905C13.963 6.65947 12.5204 5.21683 10.7408 5.21683C8.96119 5.21683 7.51855 6.65947 7.51855 8.43905C7.51855 10.2186 8.96119 11.6613 10.7408 11.6613Z"
        fill="#5C913B"
      />
      <path
        d="M21.4815 9.51303C23.2611 9.51303 24.7037 8.07039 24.7037 6.2908C24.7037 4.51121 23.2611 3.06857 21.4815 3.06857C19.7019 3.06857 18.2593 4.51121 18.2593 6.2908C18.2593 8.07039 19.7019 9.51303 21.4815 9.51303Z"
        fill="#226699"
      />
      <path
        d="M31.1483 15.9575C32.9278 15.9575 34.3705 14.5148 34.3705 12.7353C34.3705 10.9557 32.9278 9.51303 31.1483 9.51303C29.3687 9.51303 27.926 10.9557 27.926 12.7353C27.926 14.5148 29.3687 15.9575 31.1483 15.9575Z"
        fill="#DD2E44"
      />
      <path
        d="M30.074 25.6242C31.8536 25.6242 33.2963 24.1815 33.2963 22.4019C33.2963 20.6224 31.8536 19.1797 30.074 19.1797C28.2944 19.1797 26.8518 20.6224 26.8518 22.4019C26.8518 24.1815 28.2944 25.6242 30.074 25.6242Z"
        fill="#FFCC4D"
      />
    </svg>
  );
};

export default Palette;
